import { Link } from "@tanstack/react-router";
import { Phone, CalendarCheck } from "lucide-react";
import { BUSINESS } from "./constants";

export function CTASection({ headline, sub }: { headline?: string; sub?: string }) {
  return (
    <section className="storm-bg text-brand-foreground">
      <div className="mx-auto max-w-5xl px-4 py-14 text-center">
        <h2 className="text-3xl md:text-4xl font-display font-bold">
          {headline ?? "Get Your Free Roof Inspection & Estimate"}
        </h2>
        <p className="mt-3 text-base md:text-lg opacity-85 max-w-2xl mx-auto">
          {sub ?? `Honest inspections, straight answers, and fair pricing from a local family-owned roofer. Call ${BUSINESS.phone} or request an inspection online.`}
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href={BUSINESS.phoneHref} className="btn-cta w-full sm:w-auto">
            <Phone className="size-5" /> Call {BUSINESS.phone}
          </a>
          <Link to="/contact" className="btn-outline-light w-full sm:w-auto">
            <CalendarCheck className="size-5" /> Schedule My Free Roof Inspection
          </Link>
        </div>
        <div className="mt-5 text-xs opacity-70">{BUSINESS.license} · Licensed & Insured · {BUSINESS.serviceArea}</div>
      </div>
    </section>
  );
}
